<template>
  <transition name="show-up">
    <div
      v-if="!closed"
      :class="{expanded: expanded}"
      class="d-container elevation-6" >
      <v-toolbar class="status-bar" >
        <v-toolbar-title>{{status}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          @click="toggleExpanded"
          class="expand"
          icon>
          <v-icon>keyboard_arrow_down</v-icon>
        </v-btn>
        <v-btn
          @click="close"
          icon>
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <div v-if="total > 0" key="wrapper-list" class="wrapper-list" ref="wrapperList" >
        <d-files-list :filesByState="filesByState" />
      </div>
      <div v-else key="wrapper-loader" class="wrapper-loader">
        <v-progress-circular indeterminate class="primary--text" size="80" />
      </div>
    </div>
  </transition>
</template>

<script>
  import DFilesList from './DFilesList.vue'
  import $state from '../download-state.js'
  import FILES_STATES from '../file-states.js'
  import bus from '~/bus.js'
  import { useBusUtils } from '~/commons/busUtils'
  const { BusHandlerManager } = useBusUtils()
  const bhm = new BusHandlerManager()

  export default {
    name: 'd-container',
    components: {'d-files-list': DFilesList},
    props: {
      active: Boolean
    },
    created () {
      $state.$on('downloadStart', () => {
        this.$set(this, 'closed', false)
      })
    },
    data () {
      return {
        closed: true,
        expanded: true,
        scrollDown: false,
        checkDownloads: false
      }
    },
    updated () {
      if (this.scrollDown) {
        this.scrollDown = false
        // hacking time
        this.$nextTick(() => {
          ;(function ($this) {
            setTimeout(() => {
              $this.$refs.wrapperList.scrollTop = $this.$refs.wrapperList.scrollHeight
            }, 0)
          }(this))
        })
      }
    },
    mounted () {
      bhm.listenRoundTripEvents(bus, 'check-download-idleness', (payload) => {
        return new Promise((resolve, reject) => {
          if (!this.downloadInProgress) {
            return resolve()
          }
          this.checkDownloads = resolve
        })
      })
    },
    methods: {
      toggleExpanded (event) {
        if (this.expanded) {
          const listItemHeight = getComputedStyle(this.$refs.wrapperList.childNodes[0].childNodes[0]).height
          this.$refs.wrapperList.style.height = (parseFloat(listItemHeight) * (this.total > 4 ? 4 : this.total) + 16) + 'px'
          ;(() => {})(this.$refs.wrapperList.offsetHeight)
        }
        this.expanded = !this.expanded
      },
      close () {
        this.closed = true
        $state.clearFiles()
      }
    },
    computed: {
      files () {
        return $state.files
      },
      filesByState () {
        return $state.filesByState
      },
      filesState () {
        let filesStates = {
          [FILES_STATES.pending]: 0,
          [FILES_STATES.completed]: 0,
          [FILES_STATES.canceled]: 0,
          [FILES_STATES.error]: 0,
          [FILES_STATES.uploading]: 0
        }

        for (let key in $state.files) {
          const fileState = $state.files[key].state
          filesStates[fileState] += 1
        }

        return filesStates
      },
      total () {
        return Object.keys($state.files).length
      },
      status () {
        const {completed, error, pending} = this.filesState

        if (pending > 0) {
          const s = (pending !== 1 ? 's' : '')
          return this.$tf('files file' + s + ' pending', {files: pending})
        } else if (error > 0) {
          const s = (error !== 1 ? 's' : '')
          return this.$tf('files error' + s + ' ' + (s ? 'have' : 'has') + ' occurred while downloading', {files: error})
        }

        const s = (completed !== 1 ? 's' : '')
        return this.$tf('files file' + s + ' ' + (s ? 'have' : 'has') + ' been downloaded', {files: completed})
      },
      downloadInProgress () {
        return (Object.keys(this.filesByState[FILES_STATES.downloading]).length +
          Object.keys(this.filesByState[FILES_STATES.pending]).length) > 0
      }
    },
    watch: {
      active (isActive) {
        if (!isActive) {
          this.close()
        }
      },
      files (newValue, oldValue) {
        const pastFiles = Object.keys(oldValue).length
        const futureFiles = Object.keys(newValue).length
        if (futureFiles > pastFiles) {
          this.closed = false
          this.expanded = true
          this.scrollDown = true
        }
      },
      expanded (expanded) {
        const wrapperListWidth = getComputedStyle(this.$refs.wrapperList).width
        const listItemHeight = getComputedStyle(this.$refs.wrapperList.childNodes[0].childNodes[0]).height
        const maxHeight = (parseFloat(listItemHeight) * (this.total > 4 ? 4 : this.total) + 16) + 'px'
        if (expanded) {
          this.$refs.wrapperList.style.height = maxHeight
          this.$refs.wrapperList.style.width = 'auto'
        } else {
          this.$refs.wrapperList.style.height = maxHeight
          ;(() => {})(this.$refs.wrapperList.offsetHeight)
          this.$refs.wrapperList.style.width = wrapperListWidth
          this.$refs.wrapperList.style.height = '0px'
        }
      },
      downloadInProgress (val) {
        if (!val && typeof this.checkDownloads === 'function') {
          this.checkDownloads()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .show-up-enter-active,
  .show-up-leave-active {
    transition: .5s ease-out;
  }

  .show-up-enter,
  .show-up-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }

  .wrapper-list {
    transition: .5s ease;
    max-height: 240px;
    overflow: auto;
    will-change: height;
    overflow-y: auto;
  }

  .wrapper-loader {
    text-align: center;
    padding: 2rem;
    background-color: white;
  }

  .expand {
    transition: .24s ease;
    transform: rotate(-180deg);

    .expanded & {
      transform: rotate(0deg);
    }
  }

  // .status-bar {
  //   background-color: #323232;
  //   color: #f1f1f1;

  //   .icon {
  //     color: #ddd !important;
  //   }
  // }
</style>



// WEBPACK FOOTER //
// src/plugins/uploader/components/DContainer.vue